import { FeedbackStatus, FeedbackType, IGetFeedbacksDTO } from '@/models/feedback.model';
import { TGetFeedbacksQuery } from '../helpers/types';

class GetFeedbacksDTO implements IGetFeedbacksDTO {
  comment?: string;
  type: FeedbackType;
  name?: string;
  phone?: string;
  email?: string;
  status?: FeedbackStatus;
  date_from?: string;
  date_to?: string;
  model_name?: string;
  model_id?: string;
  title?: string;
  organization_tax_code?: string;
  manager_id?: string;
  target?: string;
  source?: string;
  page?: number;

  constructor({
    type,
    page,
    comment,
    date_from,
    date_to,
    email,
    model_id,
    model_name,
    title,
    organization_tax_code,
    manager_id,
    name,
    phone,
    status,
  }: TGetFeedbacksQuery & {
    page: number;
    type: FeedbackType;
  }) {
    this.page = page;
    this.type = type;
    this.comment = comment;
    this.date_from = date_from;
    this.date_to = date_to;
    this.email = email;
    this.model_id = model_id;
    this.model_name = model_name;
    this.title = title;
    this.organization_tax_code = organization_tax_code;
    this.manager_id = manager_id;
    this.name = name;
    this.phone = phone;
    this.status = status;
  }
}

export default GetFeedbacksDTO;
